const namespaced = true

const state = {
  eventName:'',
  eventLocation:null,
  protectGroupEnabled: true,
  protectGroupPremium: 0
}

const mutations = {
  updateEventLocation(state, location) { // Namespaced
    state.eventLocation = location
  },
}

export default {
  namespaced,
  state,
  mutations,
}
